import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a90e416"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "create-merchant",
  style: {"display":"inline"}
}
const _hoisted_2 = {
  key: 0,
  class: "create-merchant-modal flex flex-col popover-container"
}
const _hoisted_3 = { class: "flex justify-around" }
const _hoisted_4 = { class: "flex justify-end gap-2" }

import Btn from '@ds/components/Btn/Btn.vue';
import { computed, ref } from 'vue';
import InputField from '@ds/components/InputField/InputField.vue';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import useErrorContent from '@shared/utils/useErrorContent';
import { useAllMerchantsStore } from '@apps/ops/src/store';
import router from '@apps/ops/src/router';

type State = 'default' | 'loading' | 'success' | 'error';

type KycTiers = 'LIGHT_KYC' | 'STANDARD_KYC' | 'ADVANCED_KYC';

type RequestValues = {
	displayName: string;
	description: string | null;
	defaultKycTier: KycTiers;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateMerchant',
  setup(__props) {

const { t } = useI18n();
const { getErrorInfo } = useErrorContent();
const allMerchantsStore = useAllMerchantsStore();
const options = {
	headers: {
		'Merchant-Code': process.env.VUE_APP_PAYAUT_MERCHANT_CODE,
		'Merchant-Division-Code': process.env.VUE_APP_PAYAUT_DIVISION_CODE,
		'Payaut-Populate-Code-Fields': 'generate',
	},
};

const kycTiers: { value: KycTiers; label: string }[] = [
	{ value: 'LIGHT_KYC', label: 'Light KYC' },
	{ value: 'STANDARD_KYC', label: 'Standard KYC' },
	{ value: 'ADVANCED_KYC', label: 'Advanced KYC' },
];

const showNewMerchantModal = ref(false);
const currentState = ref<State>('default');
const currentError = ref('');

const defaultRequestValues: RequestValues = {
	displayName: '',
	description: null,
	defaultKycTier: kycTiers[2].value,
};
const requestValues = ref({ ...defaultRequestValues });

const setTier = (value: KycTiers) => {
	requestValues.value.defaultKycTier = value;
};

const closeCreateMerchantModal = () => {
	showNewMerchantModal.value = false;
	requestValues.value = { ...defaultRequestValues };
	currentState.value = 'default';
	currentError.value = '';
};

const handleCreateMerchant = async () => {
	currentState.value = 'loading';
	try {
		const data = await axios.post(
			'accountowner/api/v2/accountowners/merchants',
			{
				displayName: requestValues.value.displayName,
				description: requestValues.value.description,
				defaultKycTier: requestValues.value.defaultKycTier,
			},
			options
		);
		if (data) {
			const merchantCode = data.data.code;
			await allMerchantsStore.fetchAllDivisions(merchantCode);
			const divisionCode = await allMerchantsStore.divisionsData[0].code;

			if (!!merchantCode && !!divisionCode) {
				/**
				 * Divisions are created asynchronously
				 * so some times are not available for the UI
				 * if they are redirect user to newly created
				 * merchant/division
				 */
				await router.replace({
					path: '/',
					query: {
						merchantCode,
						divisionCode,
					},
				});
			}
			currentState.value = 'success';
		}
	} catch (error) {
		getErrorInfo(error);
		if (error.response?.status === 400 || error.response?.status === 409)
			currentError.value = error.response.data.message;
		currentState.value = 'error';
	}
};

const generateMessage = computed(() => {
	if (currentState.value === 'error') {
		return currentError.value ? currentError.value : t('ops.createMerchant.labels.error');
	}
	if (currentState.value === 'success') return t('ops.createMerchant.labels.success');
	return '';
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Btn, {
      class: "ml-1",
      ariaLabel: _ctx.$t('ops.createMerchant.title'),
      label: _ctx.$t('ops.createMerchant.title'),
      "icon-name": "bx-plus",
      size: "normal",
      variant: "secondary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showNewMerchantModal.value = !showNewMerchantModal.value))
    }, null, 8, ["ariaLabel", "label"]),
    (showNewMerchantModal.value)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _createVNode(InputField, {
            type: "text",
            label: _ctx.$t('ops.createMerchant.displayName'),
            disabled: currentState.value === 'success',
            onInput: _cache[1] || (_cache[1] = (text) => (requestValues.value.displayName = text.toString().trim()))
          }, null, 8, ["label", "disabled"]),
          _createVNode(InputField, {
            type: "text",
            label: _ctx.$t('ops.createMerchant.description'),
            disabled: currentState.value === 'success',
            onInput: _cache[2] || (_cache[2] = (text) => (requestValues.value.description = text.toString().trim()))
          }, null, 8, ["label", "disabled"]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(kycTiers, (tier) => {
              return _createVNode(Btn, {
                key: tier.value,
                label: tier.label,
                variant: "secondary",
                size: "small",
                "icon-name": tier.value === requestValues.value.defaultKycTier ? 'bx-check' : '',
                disabled: tier.value === requestValues.value.defaultKycTier,
                onClick: ($event: any) => (setTier(tier.value))
              }, null, 8, ["label", "icon-name", "disabled", "onClick"])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Btn, {
              onClick: closeCreateMerchantModal,
              label: currentState.value === 'success' ? _ctx.$t('globals.close') : _ctx.$t('globals.cancel'),
              variant: "secondary"
            }, null, 8, ["label"]),
            _createVNode(Btn, {
              label: _ctx.$t('globals.create'),
              disabled: requestValues.value.displayName === '' || currentState.value === 'success',
              "is-loading": currentState.value === 'loading',
              type: "button",
              onClick: handleCreateMerchant
            }, null, 8, ["label", "disabled", "is-loading"])
          ]),
          _createElementVNode("div", null, [
            (currentState.value === 'error' || currentState.value === 'success')
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass({
						'text-success-400': currentState.value === 'success',
						'text-error-400': currentState.value === 'error',
					})
                }, _toDisplayString(generateMessage.value), 3))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, closeCreateMerchantModal]
  ])
}
}

})